export const DECIMAL_INPUT_TEXTS = {
  thousands:
    'No separes los miles con punto ni con coma: el punto o la coma solo indican los decimales (ej.: 1234,5).',
  invalid: 'Ingresá solo números, con punto o coma para los decimales.',
  decimals: (count) => `Se admiten hasta ${count} decimales.`,
};
